import { datadogLogs } from "@datadog/browser-logs";
import { GlobeAltIcon } from "@heroicons/react/24/solid";
import { CalendarIcon, formatDateWithOrdinal } from "common";
import Footer from "common/src/components/Footer";
import { Link, useParams } from "react-router-dom";
import DefaultLogoImage from "../../assets/default_logo.png";
import { ReactComponent as GithubIcon } from "../../assets/github-logo.svg";
import { ReactComponent as TwitterIcon } from "../../assets/twitter-logo.svg";
import { APPLICATION_QUESTIONS } from "../../constants";
import { useRoundById } from "../../context/RoundContext";
import { getApplicationAnswers, getProjectURIComponents } from "../../utils";
import Breadcrumb from "../common/Breadcrumb";
import Navbar from "../common/Navbar";
import RoundEndedBanner from "../common/RoundEndedBanner";
import { ApplicationFormAnswers, DescriptionTitle, Detail, DetailSummary, Header, ProjectTitle } from "./common";
import { useEffect, useState } from "react";
import { fetchFromIPFS } from "../api/utils";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IAM_SERVER = "did:key:z6MkghvGHLobLEdj1bgRLhS4LPGJAvbMA1tn2zcRyqmYU5LC";
export default function ViewApplicationDetails() {
  var _round$approvedProjec, _projectToRender$proj, _projectToRender$proj2;
  datadogLogs.logger.info("====> Route: /round/:chainId/:roundId/:applicationId");
  datadogLogs.logger.info(`====> URL: ${window.location.href}`);
  const {
    chainId,
    roundId,
    applicationId
  } = useParams();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {
    round,
    isLoading
  } = useRoundById(chainId, roundId);
  const projectToRender = round === null || round === void 0 ? void 0 : (_round$approvedProjec = round.approvedProjects) === null || _round$approvedProjec === void 0 ? void 0 : _round$approvedProjec.find(project => project.grantApplicationId === applicationId);
  const {
    registryAddress,
    id
  } = getProjectURIComponents((projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj = projectToRender.projectMetadata) === null || _projectToRender$proj === void 0 ? void 0 : _projectToRender$proj.id) || "");
  const currentTime = new Date();
  const isAfterRoundEndDate = round && round.roundEndTime <= currentTime;
  const breadCrumbs = [{
    name: "Explorer Home",
    path: "/"
  }, {
    name: "Project Details",
    path: `/round/${chainId}/${roundId}/${applicationId}/registry/${registryAddress}/project/${id}`
  }, {
    name: "Application Details",
    path: `/round/${chainId}/${roundId}/${applicationId}`
  }];
  const applicationAnswers = getApplicationAnswers((projectToRender === null || projectToRender === void 0 ? void 0 : projectToRender.grantApplicationFormAnswers) || []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {}), isAfterRoundEndDate && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(RoundEndedBanner, {})
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative top-16 lg:top-24 lg:mx-20 h-screen px-4 py-7",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-col pb-6",
        "data-testid": "bread-crumbs",
        children: /*#__PURE__*/_jsx(Breadcrumb, {
          items: breadCrumbs
        })
      }), /*#__PURE__*/_jsx("main", {
        className: "flex flex-col items-center",
        children: !isLoading && projectToRender && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Header, {
            bannerHash: applicationAnswers.get(APPLICATION_QUESTIONS.BANNER),
            logoHash: applicationAnswers.get(APPLICATION_QUESTIONS.LOGO)
          }), /*#__PURE__*/_jsx("div", {
            className: "flex flex-col md:flex-row xl:max-w-[1800px] w-full",
            children: /*#__PURE__*/_jsxs("div", {
              className: "grow",
              children: [/*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(ProjectTitle, {
                  title: applicationAnswers.get(APPLICATION_QUESTIONS.NAME) || ""
                }), /*#__PURE__*/_jsx(AboutProject, {
                  projectToRender: projectToRender,
                  applicationAnswers: applicationAnswers,
                  registryAddress: registryAddress,
                  id: id
                })]
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(DescriptionTitle, {
                  title: "Project Description"
                }), /*#__PURE__*/_jsx(Detail, {
                  text: projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj2 = projectToRender.projectMetadata) === null || _projectToRender$proj2 === void 0 ? void 0 : _projectToRender$proj2.description,
                  testID: "project-metadata"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-10",
                children: [/*#__PURE__*/_jsx(DescriptionTitle, {}), /*#__PURE__*/_jsx(Detail, {
                  text: applicationAnswers.get(APPLICATION_QUESTIONS.DESCRIPTION) || "",
                  testID: "project-metadata"
                }), /*#__PURE__*/_jsx(ApplicationFormAnswers, {
                  answers: projectToRender.grantApplicationFormAnswers
                })]
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "my-11",
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })]
  });
}
function AboutProject(props) {
  var _projectToRender$proj3, _projectToRender$proj4, _projectToRender$proj5, _projectToRender$proj6, _projectToRender$proj7;
  const {
    projectToRender,
    applicationAnswers,
    registryAddress,
    id
  } = props;
  const {
    chainId,
    roundId,
    applicationId
  } = useParams();
  const [verificationTweet, setVerificationTweet] = useState("");
  const projectWebsite = applicationAnswers.get(APPLICATION_QUESTIONS.WEBSITE);
  const projectTwitter = projectToRender.projectMetadata.projectTwitter;
  const userGithub = projectToRender.projectMetadata.userGithub;
  const projectGithub = projectToRender.projectMetadata.projectGithub;
  const logoHash = projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj3 = projectToRender.projectMetadata) === null || _projectToRender$proj3 === void 0 ? void 0 : _projectToRender$proj3.logoImg;
  const projectLogoImage = logoHash ? `https://${process.env.REACT_APP_PINATA_GATEWAY}/ipfs/${logoHash}` : DefaultLogoImage;
  const metaDataPtr = projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj4 = projectToRender.projectMetadata) === null || _projectToRender$proj4 === void 0 ? void 0 : (_projectToRender$proj5 = _projectToRender$proj4.metaPtr) === null || _projectToRender$proj5 === void 0 ? void 0 : _projectToRender$proj5.pointer;
  const date = new Date((_projectToRender$proj6 = projectToRender.projectMetadata.createdAt) !== null && _projectToRender$proj6 !== void 0 ? _projectToRender$proj6 : 0);
  const formattedDateWithOrdinal = `Created on: ${formatDateWithOrdinal(date)}`;
  useEffect(() => {
    if (!metaDataPtr) return;
    const fetchMetaData = async () => {
      try {
        const metaData = await fetchFromIPFS(metaDataPtr);
        if (metaData !== null && metaData !== void 0 && metaData.tweetURL) {
          setVerificationTweet(metaData.tweetURL);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchMetaData();
  }, [metaDataPtr]);
  return /*#__PURE__*/_jsxs("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 border-b-2 pt-2 pb-6 [&>a]:inline-flex",
    children: [/*#__PURE__*/_jsx(Link, {
      to: `/round/${chainId}/${roundId}/${applicationId}/registry/${registryAddress}/project/${id}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center mt-2",
        "data-testid": "project-owner",
        children: [/*#__PURE__*/_jsx("img", {
          className: "h-8 w-8 rounded-full mr-2 ring-4 ring-white bg-white",
          src: projectLogoImage,
          alt: "Project Logo"
        }), /*#__PURE__*/_jsxs("p", {
          children: ["By", " ", /*#__PURE__*/_jsx("span", {
            style: {
              color: "rgb(37 99 235)"
            },
            className: "underline",
            children: projectToRender === null || projectToRender === void 0 ? void 0 : (_projectToRender$proj7 = projectToRender.projectMetadata) === null || _projectToRender$proj7 === void 0 ? void 0 : _projectToRender$proj7.title
          })]
        })]
      })
    }), projectWebsite && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GlobeAltIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: projectWebsite,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${projectWebsite}`,
          testID: "project-website"
        })
      })]
    }), projectTwitter && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(TwitterIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://twitter.com/${projectTwitter}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `@${projectTwitter}`,
          testID: "project-twitter"
        })
      }), verificationTweet && /*#__PURE__*/_jsx("div", {
        className: "text-base text-green-900 mt-1",
        children: /*#__PURE__*/_jsx("a", {
          href: verificationTweet,
          target: "_blank",
          rel: "noreferrer",
          children: "Verification Tweet"
        })
      })]
    }), projectToRender.projectMetadata.createdAt && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(CalendarIcon, {
        className: "h-4 w-4 mr-1 opacity-80"
      }), /*#__PURE__*/_jsx(DetailSummary, {
        text: `${formattedDateWithOrdinal}`,
        testID: "project-createdAt"
      })]
    }), userGithub && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GithubIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://github.com/${userGithub}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${userGithub}`,
          testID: "user-github"
        })
      })]
    }), projectGithub && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center mt-4 gap-1",
      children: [/*#__PURE__*/_jsx(GithubIcon, {
        className: "h-4 w-4 mr-1 opacity-40"
      }), /*#__PURE__*/_jsx("a", {
        href: `https://github.com/${projectGithub}`,
        target: "_blank",
        rel: "noreferrer",
        className: "text-base font-normal text-black",
        children: /*#__PURE__*/_jsx(DetailSummary, {
          text: `${projectGithub}`,
          testID: "project-github"
        })
      })]
    })]
  });
}